import {Routes} from '@angular/router';
import {routes as emailRoutes} from './emails/email.routes';
import {routes as publicationRoutes} from './publications/publications.routes';
import {routes as teamMemberRoutes} from './team-members/team-members.routes';
import {routes as userRoutes} from './users/users.routes';
import {routes as diagnosisRoutes} from './diagnoses/diagnoses.routes';
import {PERMISSION} from '@generated-backend-types';
import {
  PatientsLogin
} from './patients-login/patients-login.component';

export const routes: Routes = [
  {
    path: 'emails',
    children: emailRoutes,
    data: {
      breadcrumb: []
    }
  },
  {
    path: 'publications',
    children: publicationRoutes,
    data: {
      breadcrumb: []
    }
  },
  {
    path: 'team-members',
    children: teamMemberRoutes,
    data: {
      breadcrumb: []
    }
  },
  {
    path: 'patients-login',
    component: PatientsLogin,
    data: {
      allPermissionsNeeded: [PERMISSION.PATIENTAUTHENTICATIONAUDIT_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.patients-login.breadcrumb',
          translate: true,
          route: '/patients-login'
        },
      ]
    }
  },
  {
    path: 'users',
    children: userRoutes,
    data: {
      breadcrumb: []
    }
  },
  {
    path: 'diagnoses',
    children: diagnosisRoutes,
    data: {
      breadcrumb: []
    }
  },
];
